import { LOCALE_DEFINITIONS } from "@time-tracker/config/locales";

/**
 * Filter supported locales based on a search term.
 */
export function filterLocales(search: string) {
  const trimmed = search.trim().toLowerCase();
  if (!trimmed) {
    return [...LOCALE_DEFINITIONS];
  }
  return LOCALE_DEFINITIONS.filter(
    (l) =>
      l.label.toLowerCase().includes(trimmed) ||
      l.englishLabel.toLowerCase().includes(trimmed) ||
      l.code.toLowerCase().includes(trimmed),
  );
}

/**
 * Resolves a locale definition from its code.
 */
export function resolveLocaleDefinition(code: string) {
  return LOCALE_DEFINITIONS.find((l) => l.code === code) ?? LOCALE_DEFINITIONS[0];
}
